// extracted by mini-css-extract-plugin
export default {"fill":"ErrorIcon_fill__xGS+T"};